import React from 'react';
import { Page } from 'seagull';
import LoadingIndicator from "./LoadingIndicator";
export default function PageLoadingState(props) {
  return /*#__PURE__*/React.createElement(Page, props, /*#__PURE__*/React.createElement(LoadingIndicator, null));
}